import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import css from './index.module.scss';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';
import gtm from 'eco-design-reliance/gtm';
import { useSvgClassNamePatch } from '../useSvgClassNamePatch';

const isI18nKey = (value?: string) => !value || /^secH/.test(value);

export default function H3() {
    const { useLang, useState, useEffect, useRouter, Link } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const cards: any[] = [
        {
            img: '',
            power: t('secH2_card1_power'),
            title: t('secH2_card1_title'),
            with: t('secH2_card1_with'),
            link_more: (() => {
                const localMap: any = {
                    eu: 'https://eu.ecoflow.com/products/500w-alternator-charger?variant=50705288986967',
                    nl: 'https://eu.ecoflow.com/products/500w-alternator-charger?variant=51194422853908',
                    uk: 'https://uk.ecoflow.com/products/500w-alternator-charger?variant=51029173207379',
                    de: 'https://de.ecoflow.com/products/500w-alternator-charger?variant=56058523713917',
                    fr: 'https://fr.ecoflow.com/products/500w-alternator-charger?variant=50611851395419',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    eu: '10039883366743',
                    uk: '9919496257875',
                    de: '15240631910781',
                    fr: '9910882697563',
                    nl: '9935712747796',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    eu: '50705288986967',
                    uk: '51029173207379',
                    de: '56058523713917',
                    fr: '50611851395419',
                    nl: '51194422853908',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secH2_card1_desc1'), t('secH2_card1_desc2')],
        },
        {
            img: '',
            power: t('secH2_card2_power'),
            title: t('secH2_card2_title'),
            with: t('secH2_card2_with'),
            link_more: (() => {
                const localMap: any = {
                    eu: 'https://eu.ecoflow.com/products/800w-alternator-charger?variant=48080282714455',
                    nl: 'https://nl.ecoflow.com/products/800w-alternator-charger?variant=51194409582868',
                    uk: 'https://uk.ecoflow.com/products/800w-alternator-charger?variant=48154485850451',
                    de: 'https://de.ecoflow.com/products/800w-alternator-charger?variant=48824788844879',
                    fr: 'https://fr.ecoflow.com/products/800w-alternator-charger?variant=48299329552731',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    eu: '8989474685271',
                    uk: '8896902037843',
                    de: '9242873299279',
                    fr: '9194435346779',
                    nl: '9935708881172',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    eu: '48080282714455',
                    uk: '48154485850451',
                    de: '48824788844879',
                    fr: '48299329552731',
                    nl: '51194409582868',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secH2_card2_desc1'), t('secH2_card2_desc2')],
        },
        {
            img: '',
            power: t('secH2_card3_power'),
            title: t('secH2_card3_title'),
            with: t('secH2_card3_with'),
            link_more: (() => {
                const localMap: any = {
                    eu: 'https://eu.ecoflow.com/products/500w-alternator-charger?variant=50705289052503',
                    nl: 'https://nl.ecoflow.com/products/500w-alternator-charger?variant=51194422919444',
                    uk: 'https://uk.ecoflow.com/products/500w-alternator-charger?variant=51029173272915',
                    de: 'https://de.ecoflow.com/products/500w-alternator-charger?variant=56058523779453',
                    fr: 'https://fr.ecoflow.com/products/500w-alternator-charger?variant=50611851460955',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    eu: '10039883366743',
                    uk: '9919496257875',
                    de: '15240631910781',
                    fr: '9910882697563',
                    nl: '9935712747796',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    eu: '50705289052503',
                    uk: '51029173272915',
                    de: '56058523779453',
                    fr: '50611851460955',
                    nl: '51194422919444',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secH2_card3_desc1'), t('secH2_card3_desc2'), t('secH2_card3_desc3')],
        },
        {
            img: '',
            power: t('secH2_card4_power'),
            title: t('secH2_card4_title'),
            with: t('secH2_card4_with'),
            link_more: (() => {
                const localMap: any = {
                    eu: 'https://eu.ecoflow.com/products/500w-alternator-charger?variant=50705289183575',
                    nl: 'https://nl.ecoflow.com/products/500w-alternator-charger?variant=51194423050516',
                    uk: 'https://uk.ecoflow.com/products/500w-alternator-charger?variant=51029173403987',
                    de: 'https://de.ecoflow.com/products/500w-alternator-charger?variant=56058523910525',
                    fr: 'https://fr.ecoflow.com/products/500w-alternator-charger?variant=50611851592027',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    eu: '10039883366743',
                    uk: '9919496257875',
                    de: '15240631910781',
                    fr: '9910882697563',
                    nl: '9935712747796',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    eu: '50705289183575',
                    uk: '51029173403987',
                    de: '56058523910525',
                    fr: '50611851592027',
                    nl: '51194423050516',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secH2_card4_desc1'), t('secH2_card4_desc2'), t('secH2_card4_desc3')],
        },
    ];
    const [cardLists, setCardLists] = useState([...cards]);
    const [gap, setGap] = useState(24);
    const enableSvgClassNamePatch = useSvgClassNamePatch();

    const handleBuy = (card: any) => {
        enableSvgClassNamePatch();
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: card?.title || card?.productTitle || card?.skuTitle,
                product_name: card?.title || card?.productTitle || card?.skuTitle,
                price: card?.price,
                tag: card?.tag || 'none',
                quantity: 1,
                button_name: t('common_card_buy') || 'Buy Now',
            });
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            const { price, compareAtPrice, inventoryPolicy, inventoryQuantity, productId, variantId, variantImg, img, productTitle, skuTitle } = card;
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
                {
                    price,
                    compareAtPrice,
                    inventoryPolicy,
                    inventoryQuantity,
                    productId,
                    variantId,
                    variantImg,
                    img,
                    productTitle,
                    skuTitle,
                    quantity: 1,
                } as ItfEcoCartItem,
            ]);
        }
    };

    useEffect(() => {
        const resetGap = () => {
            const winW = window.innerWidth;
            if (winW >= 1440) {
                return setGap(24);
            } else if (winW > 1024) {
                return setGap(20);
            } else {
                return setGap(16);
            }
        };
        resetGap();
    }, []);

    useEffect(() => {
        const tempArr = [...cards];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (res?.data?.handle) {
                            tempArr[k].link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                        }
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                        return resolve({ ...tempArr?.[k], ...res?.data });
                    } else {
                        console.error(res?.message);
                        return reject({ ...tempArr?.[k] });
                    }
                } catch (e) {
                    console.error(e);
                    return reject({ ...tempArr?.[k] });
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then((res: any) => {
                setCardLists(res);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="vanlife-roadtrips-H2" data-comp="H3" className={`vanlife-roadtrips-H3 ${css['vanlife-roadtrips-H3']}`}>
            <Swiper
                className="oc-product-slider"
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                modules={[Navigation]}
                navigation
            >
                {cardLists?.map((card: any, k: number) => {
                    const label = card?.label || card?.power;
                    const soldOut = Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue';
                    return (
                        <SwiperSlide className={`oc-product-slider__item oc-product-slider__item--${k + 1}`} key={k}>
                                <div className="oc-product-slider__card">
                                    <EFPicture
                                        className="oc-product-slider__img"
                                        src={card?.variantImg || card?.img}
                                        alt={card?.title || card?.productTitle || card?.skuTitle}
                                    />
                                    <div className="oc-product-slider__body">
                                        {!isI18nKey(label) && <p className="oc-product-slider__label">{label}</p>}
                                        <p className="oc-product-slider__title">{card?.title || card?.productTitle || card?.skuTitle}</p>
                                        <ul className="oc-product-slider__descs">
                                            {card?.descArr
                                                ?.filter((desc: any) => desc)
                                                .map((desc: any, m: number) => (
                                                    <li className="oc-product-slider__desc" key={`${k}_${m}`}>
                                                        {desc}
                                                    </li>
                                                ))}
                                        </ul>
                                        {card?.with && <p className="oc-product-slider__works">{t('secH_card_works')}</p>}
                                        {card?.with && <p className="oc-product-slider__with">{card?.with}</p>}
                                    </div>
                                </div>
                                <div className="oc-product-slider__btns">
                                    {card?.link_buy && (
                                        <>
                                            {soldOut ? (
                                                <button disabled className="oc-product-slider__btn oc-product-slider__btn--buy oc-product-slider__btn--disabled">
                                                    <span className="oc-product-slider__btn-text">{t('common_card_out')}</span>
                                                </button>
                                            ) : (
                                                <p className="oc-product-slider__btn oc-product-slider__btn--buy" onClick={() => handleBuy(card)}>
                                                    <span className="oc-product-slider__btn-text">{t('common_card_buy')}</span>
                                                </p>
                                            )}
                                        </>
                                    )}
                                    {card?.link_more && (
                                        <Link
                                            className="oc-product-slider__btn oc-product-slider__btn--more"
                                            href={card?.link_more}
                                            target="_blank"
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'select_product',
                                                list_name: t('secH_title'),
                                                product_name: card.title,
                                                button_name: t('common_card_more'),
                                            }}
                                        >
                                            <span className="oc-product-slider__btn-text">{t('common_card_more')}</span>
                                        </Link>
                                    )}
                                </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
